module.exports = __webpack_public_path__ + "static/media/home-process-3.69faf2fb.svg";